import { LocalStorage } from '@hotjar/insights-common/lib/storage-factory';
import { Store } from '../../../store/player/types';
import { cancelNextRecordingCountdown } from './cancelNextRecordingCountdown';

/**
 * Toggle autoplay option.
 */
export const persistAutoplay = (store: Store): void => {
  const { isAutoplaying } = store.getState();

  LocalStorage.set('playbacksAutoplay', isAutoplaying);
  if (!isAutoplaying) {
    cancelNextRecordingCountdown(store);
  }
};
